import React, {useEffect, useState, useMemo} from 'react';
import useI18n from 'state/i18n';
import { TZDate } from "@date-fns/tz";
import Icon from '@etiquette-ui/icons';
import { useCollapse } from 'react-collapsed';
import { PRIMARY } from '@etiquette-ui/colors';
import { useMetronome } from 'providers/Metronome';
import { TIME_ZONE } from 'resources/constants';
import { DAYS_OF_WEEK } from 'resources/constants';
import { differenceInMilliseconds } from 'date-fns';
import { Container, CloseIcon, Body } from './styles';

import {
  getMessage,
  getAvailability,
  BASE_AVAILABILITY
} from './helpers';

export const SAFETY_PERIOD = 10;
const TIMER_LABEL = 'CATEGORY_SCHEDULE';

const Availability = ({shouldBeOpen, toggle, config}) => {
  const [i18n] = useI18n();
  const [availability, setAvailability] = useState({
    ...BASE_AVAILABILITY,
  });
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded: shouldBeOpen });
  const {registerCallback, unregisterCallback} = useMetronome();
  
  const {availability: availabilityConfig = null} = config;
  
  const currentDate = TZDate.tz(TIME_ZONE);
  const currentDay = DAYS_OF_WEEK[currentDate.getDay()];

  const waitUntilExpiration = () => {
    let {endAt} = availability;
    const timeUntilExpiration = differenceInMilliseconds(endAt, TZDate.tz(TIME_ZONE));
    if(timeUntilExpiration <= SAFETY_PERIOD){
      toggle(true);
      unregisterCallback(TIMER_LABEL);
    }
  }

  const waitUntilStart = () => {
    let {startAt} = availability;
    const timeUntilStart = differenceInMilliseconds(startAt, TZDate.tz(TIME_ZONE));
    if(timeUntilStart <= SAFETY_PERIOD){
      toggle(false);
      registerCallback(waitUntilExpiration, TIMER_LABEL);
    }
  }

  const message = useMemo(()=>{
    if(!!availability.alwaysAvailable)
      return i18n.tag('ALWAYS_AVAILABLE');
    
    return getMessage(availability.timeRanges, availability.days, i18n);
  },[availability, i18n]);

  useEffect(()=>{
    setAvailability(getAvailability(availabilityConfig));
  },[availabilityConfig]);

  useEffect(()=>{
    if(availability.alwaysAvailable) toggle(false);
    else {
      if(!!availability.days && !availability.days.includes(currentDay) 
        && availability.endsDay !== currentDay)
        toggle(true);
      else {
        if(!availability.timeRanges){
          toggle(false);
          return;
        }

        if(availability.currentOrder === 0){
          toggle(false);
          registerCallback(waitUntilExpiration, TIMER_LABEL);
        } else toggle(true);
        
        if(availability.currentOrder === -1)
          registerCallback(waitUntilStart, TIMER_LABEL);        
      }
    }

    return () => unregisterCallback(TIMER_LABEL);
  },[availability]);

  return (
    <Container {...getCollapseProps()}>
      <CloseIcon {...getToggleProps({
          onClick: ()=>toggle(false),
        })}>
        <Icon
          icon={'wrong'}
          styles={{
            svg: {
              width: '20px',
              height: '20px',
            },
            line: {
              fill: 'none',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '1.5px',
              stroke: PRIMARY,
            },
          }}
        />
      </CloseIcon>
      <Body>
        {message}
      </Body>
    </Container>
  )
}
export default Availability;